import { Text } from '@ui/lib/park/ui/text';
import { Box, Flex, Stack } from 'styled-system/jsx';

export const Row = ({
  label,
  children,
  hint,
}: {
  label: React.ReactNode;
  children: React.ReactNode;
  hint?: React.ReactNode;
}) => (
  <Flex
    justify="space-between"
    align="center"
    py="2"
    borderBottom="1px solid"
    borderBottomColor="v2.border.hairline"
  >
    <Stack gap="0">
      <Text textStyle="v2.meta" color="v2.text.muted">
        {label}
      </Text>
      {hint ? (
        <Text textStyle="v2.meta" color="v2.text.subtle">
          {hint}
        </Text>
      ) : null}
    </Stack>
    <Box textAlign="right">{children}</Box>
  </Flex>
);
